import { useCallback, useMemo, useState } from "react";

import * as ModelConverter from "@/components/features/_model/converter";

import * as Factory from "./factory";
import * as FormModelType from "./type";
import * as ValidationSchema from "./validation-schema";

export const useHotelNotificationSettingFormModel = (
	initInputModel: FormModelType.HotelNotificationSettingFormModel["InputModel"],
) => {
	const defaultInputModel = useMemo(
		() => Factory.Default.hotelNotificationSettingInputModelFactory(initInputModel.id, initInputModel.hotelID),
		[initInputModel.id, initInputModel.hotelID],
	);

	// InputModel の初期化
	const [currentInputModel, setCurrentInputModel] =
		useState<FormModelType.HotelNotificationSettingFormModel["InputModel"]>(initInputModel);

	// ViewModel の初期化
	const [viewModel, setViewModel] = useState<FormModelType.HotelNotificationSettingFormModel["ViewModel"]>(
		ModelConverter.inputModelToViewModelConverter<
			FormModelType.HotelNotificationSettingFormModel["InputModel"],
			FormModelType.ExcludeKeys,
			FormModelType.HotelNotificationSettingFormModel["QueryData"],
			ValidationSchema.HotelNotificationSettingInputZodSchemaType
		>({
			defaultInput: defaultInputModel,
			initInput: initInputModel,
			currentInput: initInputModel,
			excludeKeys: FormModelType.excludeKeys,
			zodSchema: ValidationSchema.HotelNotificationSettingInputZodSchema,
		}),
	);

	// ViewModel の更新
	const onSetViewModel = useCallback(
		(_viewModel: FormModelType.HotelNotificationSettingFormModel["ViewModel"]) => {
			const convertedInputModel = ModelConverter.viewModelToInputModelConverter(_viewModel);
			const convertedViewModel = ModelConverter.inputModelToViewModelConverter<
				FormModelType.HotelNotificationSettingFormModel["InputModel"],
				FormModelType.ExcludeKeys,
				FormModelType.HotelNotificationSettingFormModel["QueryData"],
				ValidationSchema.HotelNotificationSettingInputZodSchemaType
			>({
				defaultInput: defaultInputModel,
				initInput: initInputModel,
				currentInput: convertedInputModel,
				excludeKeys: FormModelType.excludeKeys,
				zodSchema: ValidationSchema.HotelNotificationSettingInputZodSchema,
			});
			// state の更新
			setCurrentInputModel(convertedInputModel);
			setViewModel(convertedViewModel);
		},
		[defaultInputModel, initInputModel],
	);

	const onResetViewModel = useCallback(() => {
		setViewModel((prev) => ({
			...prev,
			isDirty: false,
		}));
	}, []);

	return {
		inputModel: currentInputModel,
		viewModel,
		onSetViewModel,
		onResetViewModel,
	};
};
